<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-02 14:09:06
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-14 14:48:39
-->
<template>
	<div class="align-right" style="width: 100px">
		<div v-for="(item, index) in btnArr.default" :key="index">
			<el-tooltip class="item" effect="dark" :content="item.tips" :disabled="!item.tips" placement="left">
				<el-button :key="index" :type="item.type" :disabled="item.disabled" :plain="item.plain" @click="click(item)">
					<div
						:class="[
							item.classtype == 1 ? 'yx-color-danger' : item.classtype == 2 ? 'yx-color-primary' : '',
							item.notSelf ? 'notSelf' : '',
							'font-h6-regular',
						]"
					>
						{{ item.label }}
					</div>
				</el-button>
			</el-tooltip>
		</div>
		<el-dropdown v-if="btnArr.more.length">
			<span class="el-dropdown-link yx-color-primary pointer font-h6-regular">
				更多
				<i class="el-icon-arrow-down"></i>
			</span>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item v-for="(item, index) in btnArr.more" :key="index">
					<el-tooltip class="item" effect="dark" :content="item.tips" :disabled="!item.tips" placement="left">
						<el-button :key="index" :type="item.type" :disabled="item.disabled" :plain="item.plain" @click="click(item)">
							<div
								:class="[
									item.classtype == 1 ? 'yx-color-danger' : item.classtype == 2 ? 'yx-color-primary' : '',
									item.notSelf ? 'notSelf' : '',
									'font-h6-regular',
								]"
							>
								{{ item.label }}
							</div>
						</el-button>
					</el-tooltip>
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { drRoleType } from '@/utils/dataMap';
export default {
	name: 'TextButton',
	computed: {
		...mapGetters(['isDarenPartner']),
		btnArr() {
			const { row: { operations = [] } = {} } = this;
			if (operations.length === 4) {
				return {
					default: operations.slice(0, 4),
					more: [],
				};
			} else {
				return {
					default: operations.slice(0, 3),
					more: operations.slice(3),
				};
			}
		},
		drName() {
			return drRoleType.name;
		},
	},
	props: {
		rowIndex: {
			type: Number,
			default: 0,
		},
		row: {
			type: Object,
			default: () => ({}),
		},
	},
	methods: {
		click({ click }) {
			click && click(this.row, this.rowIndex);
		},
	},
};
</script>
<style lang="less" scoped></style>
